// extracted by mini-css-extract-plugin
export var breadcrumb = "_11-0";
export var breadcrumbArrow = "_11-1";